// eslint-disable-next-line
export default {
   'partners.id': 'ID',
   'partners.partner': 'Socios',
   'partners.levelProgram': 'Nivel / Programa',
   'partners.channel': 'Canal de registro',
   'partners.filter.operationType': 'Tipo de operación',
   'partners.points': 'Puntos',
   'partners.income': 'Ingresos generados',
   'partners.lastOperation': 'Última operación',
   'partners.program': 'Programa',
   'partners.status': 'Estatus',
   'partner.importHelpText': 'Arrastra o ingresa el archivo con los usuarios a importar.',
   'partners.level': 'Nivel',
   'date.format': 'ccc. dd LLL. yy',
   'partner.information': 'Información del socio',
   'partner.history': 'Historial de actividades',
   'partner.history.operation': 'Historial de operaciones',
   'partner.history.operation.empty': 'No hay historial de operaciones para mostrar',
   'partner.membership.information': 'Información de membresía',
   'partner.name': 'Nombre',
   'partner.email': 'Correo electrónico',
   'partner.status': 'Estado civil',
   'partner.sex': 'Sexo',
   'partner.lastName': 'Apellidos',
   'partner.phone': 'Teléfono',
   'partner.birthday': 'Fecha de nacimiento',
   'partner.country': 'País de residencia',
   'partner.organization': 'Empresa',
   'partner.roleInOrganization': 'Puesto',
   'partner.points': 'Puntos',
   'partner.program': 'Programa',
   'partner.registrationChannel': 'Canal de registro',
   'partner.registrationDate': 'Fecha de registro',
   'partner.level': 'Nivel',
   'partner.segment': 'Segmento',
   'partner.numberOfPoints': '{points}puntos',
   'partner.from': 'Socio desde el {date}',
   'partner.sex.FEMALE': 'Mujer',
   'partner.sex.MALE': 'Hombre',
   'partner.status.MARRIED': 'Casado',
   'partner.status.SINGLE': 'Soltero',
   'partner.historyItem': '{points} por {service} en {name}',
   'partner.points.accumulated': '{points} puntos acumulados',
   'partner.points.redeemed': '{points} puntos redimidos',
   'partner.all.operations': 'Ver todas las operaciones',
   'partner.export.basic': 'Exportacion basica',
   'partner.export.advanced': 'Exportacion avanzada',
   'partner.import': 'Importar socios',
   'partner.createAt': 'Creado el {date}',
   'partner.create': 'Nuevo socio',
   'partner.create.tittle': 'Nuevo socio',
   'partner.form.firstName': 'Nombre',
   'partner.form.lastName': 'Apellido',
   'partner.form.email': 'Correo electrónico',
   'partner.form.status': 'Estatus',
   'partner.form.phonenumber': 'Numero de telefono',
   'partner.form.phonenumber.with_value': 'Numero de telefono {number}',
   'partner.form.birthday': 'Fecha de nacimiento',
   'partner.form.country': 'País de residencia',
   'partner.form.phone.label.info': 'Teléfono con clave lada',
   'partner.form.areaCode': 'Código de país',
   'partner.errors.firstName': 'Escribe tu(s) nombre(s)',
   'partner.errors.lastName': 'Escribe tus apellidos',
   'partner.errors.email': 'Escribe tu email',
   'partner.errors.emailFormat': 'Revisa que el formato de tu email esté correcto (micorreo@domain.com).',
   'partner.errors.areaCode': 'Escribe la Lada de tu número telefónico',
   'partner.errors.phoneNumber': 'Escribe tu número telefónico',
   'partner.errors.status': 'Requiere este campo',
   'partner.errors.birthday': 'Selecciona la fecha de nacimiento',
   'partner.errors.country': 'Selecciona el país de residencia',
   'partner.errors.loyaltyplanId': 'Requiere este campo',
   'partner.errors.levelId': 'Requiere este campo',
   'partner.status.single': 'Soltero',
   'partner.status.married': 'Casado',
   'partner.status.divorced': 'Divorciado',
   'partner.status.widowed': 'Viudo',
   'partner.status.separated': 'Separado',
   'partner.status.civil_union': 'Union civil',
   'partner.errors.gender': 'Requiere este campo',
   'partner.form.gender': 'Sexo',
   'partner.gender.MALE': 'Hombre',
   'partner.gender.FEMALE': 'Mujer',
   'partner.form.registrationChannel': 'Canal de registro',
   'partner.errors.registrationChannel': 'Requiere este campo',
   'partner.form.state': 'Estado',
   'partner.form.rfc': 'RFC',
   'partner.form.memberCode': 'Código de socio',
   'partner.form.city': 'Ciudad',
   'partner.form.municipality': 'Delegacion/Municipio',
   'partner.errors.municipality': 'Escribe tu delegación o municipio',
   'partner.form.passion': '¿Cual es tu pasion?',
   'partner.form.allergies': 'Alergias',
   'partner.form.typeBlood': 'Tipo de sangre',
   'partner.form.swimming': '¿Sabes nadar?',
   'partner.form.programs': 'Programas',
   'partner.form.level': 'Nivel',
   'partner.form.channel': 'Canal de registro',
   'partner.form.add': 'Agregar otro',
   'partner.title.additionalInformation': '{plan}: Información adicional',
   'partner.form.sourceId': 'Opera Profile Source ID',
   'partner.form.pms.perfils': 'Perfiles PMS',
   'partner.errors.birthday.invalid': 'Llena todos los campos de nacimiento',
   'partner.errors.state': 'Escribe tu estado',
   'partner.errors.city': 'Escribe tu ciudad',
   'partner.form.day': 'Día',
   'partner.form.month': 'Mes',
   'partner.form.year': 'Año',
   'partner.errors.required': 'Requiere este campo',
   'partner.title.additional': 'Información adicional',
   'partner.tittle.loyaltyPlans': 'Programas de lealtad',
   'partner.tittle.personalInformation': 'Informacion personal',
   'partner.form.January': 'Enero',
   'partner.form.February': 'Febrero',
   'partner.form.March': 'Marzo',
   'partner.form.April': 'Abril',
   'partner.form.May': 'Mayo',
   'partner.form.June': 'Junio',
   'partner.form.July': 'Julio',
   'partner.form.August': 'Agosto',
   'partner.form.September': 'Septiembre',
   'partner.form.October': 'Octubre',
   'partner.form.November': 'Noviembre',
   'partner.form.December': 'Diciembre',
   'partner.form.addres': 'Direccion',
   'partner.errors.address': 'Escribe tu dirección',
   'partner.form.ZipCode': 'Código Postal',
   'partner.errors.ZipCode': 'Escribe tu código postal',
   'partner.form.countryOfResidence': 'País',
   'partner.errors.countryOfResidence': 'Escribe tu país de residencia',
   'partners.tittle.detail': 'Detalles del socio',
   'partners.table.partner': 'Nombre',
   'partners.table.level': 'Level',
   'partners.table.channelRegister': 'Canal de registro',
   'partners.table.room.Per.Nights': 'Cuartos noche',
   'partner.edit': 'Editar socio',
   'partner.form.fields.required': 'Campos requeridos',
   'partner.create.success': 'Socio creado exitosamente',
   'partner.create.fail': 'fallo al crear socio',
   'partner.edit.success': 'Socio editado exitosamente',
   'partner.edit.fail': 'fallo al editar socio',
   'partner.import.success': 'Socios importados listos para procesar',
   'partner.import.error': 'fallo al importar socios',
   'partner.confirmation.send': 'Enviar confirmación',
   'partner.confirmation.information': 'Se le enviará al cliente un mensaje automático por correo',
   'partner.confirmation.confirm': 'Envíar',
   'partner.confirmation.cancel': 'Cancelar',
   'partner.confirmation.success': 'Confirmación enviada exitosamente',
   'partner.confirmation.fail': 'fallo al enviar confirmación',
   'partner.operation.operation': 'Operación {operation}',
   'partner.operation.from': 'Creada el {date}',
   'partner.operation.amount': 'Monto',
   'partner.operation.plan': 'Plan de lealtad',
   'partner.operation.type': 'Tipo de operación',
   'partner.operation.service': 'Tipo de servicio',
   'partner.operation.channel': 'Canal de registro',
   'partner.operation.nights': 'Número de noches',
   'partner.operation.rooms': 'Cuartos noche',
   'partner.operation.operation.date': 'Fecha de operación',
   'partner.operation.service.date': 'Fecha de servicio',
   'partner.operation.invoice': 'Factura',
   'partner.operation.reference': 'Referencia',
   'partner.operation.member': 'Socio',
   'partner.operation.member.name': 'Nombre',
   'partner.operation.member.id': 'ID de socio',
   'partner.operation.member.view.details': 'Ver detalles del socio',
   'partner.operation.reservation': 'Reservación',
   'partner.operation.hotel': 'Hotel',
   'partner.operation.code': 'Código de reservación',
   'partner.operation.member.view.reservation': 'Ver detalles de la reservacion',
   'partner.operation.members': 'Socios',
   'partner.operation.operations': 'Operaciones',
   'partner.operation.details': 'Detalles de la operación',
   'partner.operation.edit': 'Editar operación',
   'partner.operation.create': 'Crear operación',
   'partner.operation.save': 'Guardar',
   'partner.operation.cancel': 'Cancelar',
   'partner.operation.partner': 'Socio',
   'partner.operation.invoice.required': 'El número de factura es requerido',
   'partner.operation.reference.required': 'La referencia es requerida',
   'partner.titles.operations': 'Operaciones',
   'partner.titles.info': 'Información de socio',
   'partner.confirmation.deactivate': 'Desactivar',
   'partner.confirmation.activate': 'Activar',
   'partner.deactivate.message': '¿Estás seguro de que deseas desactivar este socio?',
   'partner.deactivate.tittle': 'Desactivar socio',
   'partner.activate.tittle': 'Activar socio',
   'partner.activate.message': '¿Estás seguro de que deseas activar este socio?',
   'partner.activate.success': 'Socio activado exitosamente',
   'partner.deactivate.success': 'Socio desactivado exitosamente',
   'partner.status.fail': 'fallo al cambiar el estatus del socio',
   'partner.deactivate.alert1': 'Está a punto de desactivar la cuenta de {name} ( ID: {id} )',
   'partner.activate.alert1':
      'Está a punto de activar la cuenta de {name} ( ID: {id} ). Esto permitirá que el socio vuelva a acceder al programa de lealtad.',
   'partner.desactivate.list-alert1': 'Se eliminará permanentemente su saldo en puntos',
   'partner.desactivate.list-alert2': 'Se borrará su historial de operaciones',
   'partner.desactivate.list-alert3': 'No podra volvera a acceder al programa de lealtad con esta cuenta.',
   'partner.desactivate.list-alert4': 'Se enviará un correo al socio notificandole de esta acción',
   'partner.desactivate.list-alert5': 'Confirmo que entiendo las consecuencias y deseo desactivar esta cuenta.',
   'partner.status.desactivate': 'Inactivo',
   'partner.reaon.activate': 'Nota *',
   'partner.reaon.note': 'Explica la razón de la reactivacion',
   'partner.historyItem.status': '{status} por {author}',
   'partner.operation.delete': 'Cancelar operación',
   'partner.operation.delete.id': 'Cancelar operación {id}',
   'partner.operation.delete.description':
      'Al cancelar la operación, los puntos serán devueltos o descontados según corresponda. Esta acción no se puede deshacer.',
   'partner.operation.delete.point.1': 'Los puntos utilizados serán devueltos al saldo del cliente',
   'partner.operation.delete.point.2': 'Se generará el ajuste correspondiente',
   'partner.operation.delete.confirmation': 'Confirmo que entiendo las condiciones de la cancelación.',
   'partner.operation.back': 'Regresar',
   'partner.operation.errors.confirmation': 'Acepta las condiciones de la cancelación',
   'partner.operation.delete.success': 'Operación cancelada exitosamente',
   'partner.operation.delete.fail': 'Fallo al cancelar operación',
   'partner.operation.delete.comment': 'Razón de la cancelación (opcional)',
   'partner.historyItem.type.CANCEL_OPERATION': 'Operación {id} cancelada',
   'partner.historyItem.type.MEMBER_ACTIVATE': 'Socio reactivado',
   'partner.historyItem.type.MEMBER_DEACTIVATE': 'Socio desactivado',
   'partner.historyItem.type.MEMBER_CREATE': 'Socio inscrito',
   'partner.historyItem.type.MEMBER_UPDATE': 'Socio actualizado',
   'partner.operation.transfer': 'Transferir operación',
   'partner.operation.transfer.title': 'Trasladar operación {id}',
   'partner.operation.transfer.action': 'Transferir',
   'partner.operation.transfer.confirmation':
      'Confirmo que tengo permiso de ambos socios para realizar esta transferencia.',
   'partner.operation.errors.destinationMember': 'Selecciona el socio de destino',
   'partner.operation.transfer.destinationMember': 'Cuenta destino',
   'partner.operation.transfer.originMember': 'Cuenta origen',
   'partner.operation.transfer.success': 'Operación transferida exitosamente',
   'partner.operation.transfer.fail': 'Fallo al transferir operación',
   'partner.history.empty': 'No hay historial de actividades para mostrar',
   'partner.errors.phoneNumber.length': 'El número de teléfono debe tener 10 dígitos.',
   'partner.errors.company': 'Escribe el nombre de tu empresa',
   'partner.form.company': 'Empresa',
   'partner.profile': 'Agregar perfil PMS',
   'partner.tittle.profilePMS': 'Perfiles PMS',
   'partner.form.profilePMS.id': 'Indentificador',
   'partner.form.profilePMS.type': 'Tipo',
   'partner.form.profilePMS.subType': 'Subtipo',
   'partner.form.profilePMS.error.id': 'Escribe el indentificador del perfil PMS',
   'partner.form.profilePMS.error.type': 'Escribe el tipo del perfil PMS',
   'partner.form.profilePMS.error.subType': 'Escribe el subtipo del perfil PMS',
   'partner.profile.noProfiles': 'No hay perfiles PMS para mostrar',
   'partner.form.profilePMS.title': 'Capturar perfil PMS',
   'partner.profile.add.success': 'Perfil PMS agregado exitosamente',
   'partner.profile.add.fail': 'Fallo al agregar perfil PMS',
   'partner.errors.segment': 'Selecciona el segmento',
   'partner.form.segment': 'Segmento',
   'partner.form.role_in_organization': 'Puesto',
   'partner.errors.role_in_organization': 'Escribe el puesto en la Empresa',
   'partner.notes': 'Notas',
   'partner.notes.add': 'Agregar nota',
   'partner.notes.save': 'Guardar',
   'partner.notes.cancel': 'Cancelar',
   'partner.notes.placeholder': 'Escribe tu nota aquí...',
   'partner.notes.by': 'Por {author}',
   'partner.notes.view.all': 'Ver todas las notas',
   'partner.notes.view.latest': 'Ver últimas notas',
   'partner.notes.empty': 'No hay notas para mostrar',
   'partner.notes.create.success': 'Nota creada exitosamente',
   'partner.notes.create.fail': 'Fallo al crear nota',
}
